import * as React from 'react';
import {Card, Grid} from '@mui/material';
import {RewardHistory} from "../../Gamification/RewardHistory";
import UserBadges from "../../Gamification/Badges/UserBadges";
import CardContent from "@mui/material/CardContent";
import { useAppSelector } from '../../../../hooks/hooks';

interface GamificationTabProps {
    communityName: string;
    isOwner: boolean;
}


function GamificationTab({ communityName, isOwner }: GamificationTabProps): React.ReactElement {
    const isAuthenticated = useAppSelector(state => state.login.isAuthenticated);

    return (
        <Grid container spacing={{ xs: 2, md: 5 }}>
            {isAuthenticated && (
                <>
                    {/* Reward section only for owners */}
                    {isOwner && (
                        <Grid item xs={12} md={5}>
                            <RewardSection />
                        </Grid>
                    )}

                    {/* Badge section */}
                    <Grid item xs={12} md={isOwner ? 7 : 12}>
                        <Grid item>
                            <BadgeSection communityName={communityName} isCompactView={isOwner} />
                        </Grid>
                    </Grid>
                </>
            )}
        </Grid>
    );
}

export default GamificationTab;

function RewardSection(): React.ReactElement {
    return (
        <React.Fragment>
            <Card>
                <CardContent>
                    <RewardHistory />
                </CardContent>
            </Card>
        </React.Fragment>
    );
}

function BadgeSection({communityName, isCompactView} : {communityName: string, isCompactView: boolean}): React.ReactElement {
    return (
        <React.Fragment>
            <UserBadges communityName={communityName} isCompactView={isCompactView} />
        </React.Fragment>
    );
}
